module.exports = __webpack_public_path__ + "static/media/hitdelayfixmod-code-example2.10afb66f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/hitdelayfixmod/hitdelayfixmod-code-example2.png
 ** module id = 565
 ** module chunks = 0
 **/